"use client";

import { cn } from "@jesus-central-church/shared";
import { Search, X } from "lucide-react";
import type { QuickFilter } from "./types";

export interface EventsQuickBarProperties {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  quickFilter: QuickFilter;
  onQuickFilterChange: (filter: QuickFilter) => void;
  className?: string;
}

const QUICK_FILTERS: { key: QuickFilter; label: string }[] = [
  { key: "all", label: "Alle events" },
  { key: "week", label: "Deze week" },
  { key: "month", label: "Deze maand" },
];

export function EventsQuickBar({
  searchQuery,
  onSearchChange,
  quickFilter,
  onQuickFilterChange,
  className,
}: EventsQuickBarProperties) {
  return (
    <div
      className={cn(
        "sticky top-0 z-30 border-b border-freedom/10 bg-boldness/95 backdrop-blur-md",
        className,
      )}
    >
      <div className="container mx-auto px-6 py-4 md:px-12">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Search */}
          <div className="relative flex-1 md:max-w-md">
            <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-freedom/40" />
            <input
              type="text"
              placeholder="Zoek event..."
              value={searchQuery}
              onChange={(event) => onSearchChange(event.target.value)}
              className="w-full rounded-full border border-freedom/20 bg-freedom/5 py-3 pr-4 pl-12 text-freedom placeholder-freedom/40 transition-colors focus:border-strategy-gold focus:outline-none"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange("")}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-freedom/40 hover:text-freedom"
                aria-label="Wis zoekopdracht"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>

          {/* Quick Filters */}
          <div className="flex gap-2 overflow-x-auto pb-2 md:pb-0">
            {QUICK_FILTERS.map((filter) => (
              <button
                key={filter.key}
                onClick={() => onQuickFilterChange(filter.key)}
                className={cn(
                  "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-all",
                  quickFilter === filter.key
                    ? "bg-strategy-gold text-freedom"
                    : "bg-freedom/10 text-freedom/70 hover:bg-freedom/20",
                )}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
